// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"538":"ec06904d","651":"f5410b13","686":"96f966b0","746":"776315a0"}[chunkId] + ".chunk.js";
};